import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const PakistanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15690'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15690)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M20.0006 0H5.71484V14H20.0006V0Z'
					fill='#0A632F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M16.9079 7.52542C16.8162 8.40087 16.4354 9.24207 15.7624 9.90162C14.1582 11.4737 11.501 11.4185 9.82733 9.77832C8.15366 8.13812 8.09733 5.53403 9.70152 3.96192C10.3745 3.30237 11.2329 2.92924 12.1262 2.8394C11.8448 3.00191 11.5785 3.20244 11.3353 3.44074C9.87697 4.86993 9.80483 7.1164 11.1742 8.45839C12.5436 9.80037 14.8359 9.72968 16.2943 8.30049C16.5374 8.0622 16.742 7.80118 16.9079 7.52542ZM15.0667 5.67333L14.8393 7.00224L14.2041 5.80721L12.8442 6.006L13.8077 5.04467L13.1945 3.83862L14.4252 4.43952L15.4061 3.49534L15.2033 4.82805L16.4227 5.45057L15.0667 5.67333Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default PakistanFlagIcon;
